import React, { createContext, useContext, useState, useEffect } from 'react';
import baseURL from '../Components/url';

const TimezoneContext = createContext();

export const useTimezone = () => {
    const context = useContext(TimezoneContext);
    if (!context) {
        throw new Error('useTimezone debe usarse dentro de TimezoneProvider');
    }
    return context;
};

export const TimezoneProvider = ({ children }) => {
    const [timezone, setTimezone] = useState('America/Bogota');
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarTimezone();
    }, []);

    const cargarTimezone = async () => {
        try {
            const response = await fetch(`${baseURL}/timezoneGet.php`);
            const data = await response.json();
            
            if (data.success) {
                setTimezone(data.timezone);
                setOffset(data.offset);
            }
        } catch (error) {
            console.error('Error al cargar zona horaria:', error);
            // Usar valores por defecto en caso de error
            setTimezone('America/Bogota');
            setOffset(-18000); // UTC-5
        } finally {
            setLoading(false);
        }
    };

    // Función para formatear fecha según la zona horaria del servidor
    const formatearFecha = (fechaString, formato = 'completo') => {
        if (!fechaString) return '-';
        
        try {
            const fecha = new Date(fechaString);
            
            // Ajustar la fecha según el offset del servidor
            // La fecha que viene del servidor ya está en la zona horaria correcta
            // Solo necesitamos formatearla
            
            const opciones = {
                timeZone: timezone,
            };
            
            switch (formato) {
                case 'fecha':
                    opciones.year = 'numeric';
                    opciones.month = '2-digit';
                    opciones.day = '2-digit';
                    break;
                case 'hora':
                    opciones.hour = '2-digit';
                    opciones.minute = '2-digit';
                    opciones.hour12 = false;
                    break;
                case 'completo':
                default:
                    opciones.year = 'numeric';
                    opciones.month = '2-digit';
                    opciones.day = '2-digit';
                    opciones.hour = '2-digit';
                    opciones.minute = '2-digit';
                    opciones.hour12 = false;
                    break;
            }
            
            return fecha.toLocaleString('es-ES', opciones);
        } catch (error) {
            console.error('Error al formatear fecha:', error);
            return fechaString;
        }
    };

    // Función para obtener la fecha actual en la zona horaria del servidor
    const getFechaActual = () => {
        const ahora = new Date();
        return ahora.toLocaleString('es-ES', {
            timeZone: timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    };

    const value = {
        timezone,
        offset,
        loading,
        formatearFecha,
        getFechaActual
    };

    return (
        <TimezoneContext.Provider value={value}>
            {children}
        </TimezoneContext.Provider>
    );
};

export default TimezoneContext;


